<template>
  <ul v-if="tabs.length > 0" class="km__list--modules">
    <ModuleTabsItem
        v-for="tabToDisplay in tabsRef"
        :key="tabToDisplay.id"
        :tabToDisplay="tabToDisplay"
        :tab_open="tab_open(tabToDisplay.id)"
        @show="switchTabByTablistSelect"
    />
  </ul>
</template>

<script lang="ts" setup>
import ModuleTabsItem from "./ModuleTabsItem.vue";
import {computed, onMounted, onUnmounted, ref, Ref} from "vue";
import tabs, {TabData, TabNames} from "@km/data/tabs";
import {useStore} from "vuex";
import {tabAnimationRunning} from "@km/animations/animationFactory";
import {EventListener, EventVerteiler} from "@k/global/eventVerteiler";

const eventListener = new EventListener();
const store = useStore();

onMounted(() => {
  store.commit("SET_TAB_OPEN", TabNames.DESIGNS);
});
onUnmounted(() => EventVerteiler.unsubscribe(eventListener));


const tabsRef = ref(tabs) as Ref<TabData[]>;
const tab_open = computed(() => (tabname: TabNames) => store.getters.getOpenTabName === tabname);
const switchTabByTablistSelect = (tabID: TabNames) => {
  if (tabAnimationRunning()) {
    return;
  }
  store.commit("SET_TAB_OPEN", tabID)
};

</script>

<style lang="scss" scoped>

.km__modules__navi {
  width: 100%;
  position: relative;

  .km__list--modules {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
  }
}

</style>
